import React from 'react'

export const EtherIcon = () => (
  <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
      fill="#667FE3"
    />
    <path
      d="M12.0022 5.39999C12.0022 5.39999 12.0022 10.8452 12.0022 14.333C10.319 13.4169 7.69204 11.9839 7.69204 11.9839L12.0022 5.39999Z"
      fill="#FBFBFD"
    />
    <path
      d="M12.0022 5.39999L16.3124 11.9839C16.3124 11.9839 13.6854 13.4169 12.0022 14.333C12.0022 10.8452 12.0022 5.39999 12.0022 5.39999Z"
      fill="#FBFBFD"
    />
    <path d="M12.0021 15.3521V18.6L7.69199 13.0075L12.0021 15.3521Z" fill="#FBFBFD" />
    <path d="M12.0021 18.6V15.3521L16.3125 13.0075L12.0021 18.6Z" fill="#FBFBFD" />
  </svg>
)
